export default __webpack_public_path__ + "static/media/other.893419e4.svg";